import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import * as vehiculosActions from 'modules/vehiculos/action';

/*
Props:
vehiculo
*/
@connect((store) => ({
  userRoles: store.getIn(['user', 'roles']),
}))
export default class extends React.Component {
  delete = (id) => this.props.dispatch(vehiculosActions.setState({ eliminarId: id }));
  add = (vehiculo) => this.props.dispatch(push('/dashboard/vehiculos/add/' + vehiculo.get('id')));
  render() {
    let { vehiculo, userRoles } = this.props;
    const onTouchTap = () => this.add(vehiculo);
    return (
      <MaterialUI.ListItem
        className="ptb-5"
        key={vehiculo.get('id')}
        rightIconButton={
          userRoles &&
          userRoles.find((v) => v == 'admin' || v == 'devAdmin' || v == 'administrador_vehiculos') && (
            <MaterialUI.FlatButton icon={<FontAwesome name="trash" />} onTouchTap={this.delete.bind(this, vehiculo.get('id'))} className="listIcon red" />
          )
        }
        primaryText={
          <Row onClick={onTouchTap}>
            <Col md="2">
              <FontAwesome name="bus" />
              <p className="title blue"> {vehiculo.get('nombre')} </p>
            </Col>
            <Col md="2">
              <FontAwesome name="address-card-o" />
              <p className="bolder"> {vehiculo.get('patente')} </p>
            </Col>
            <Col md="1">
              <FontAwesome name="group" />
              <p className="bolder"> {vehiculo.get('cantAsientos')} </p>
            </Col>
            {vehiculo.get('_codigo') && (
              <Col md="1">
                <FontAwesome name="qrcode" />
                <p className="bolder"> {vehiculo.getIn(['_codigo', 'codigo'])} </p>
              </Col>
            )}
            {vehiculo.get('_chofer') && (
              <Col md="3">
                <FontAwesome name="user" />
                <p className="bolder">
                  {vehiculo.getIn(['_chofer', 'nombre'])} {vehiculo.getIn(['_chofer', 'apellido'])}{' '}
                </p>
              </Col>
            )}
            {vehiculo.get('_dispositivo') && (
              <Col md="2">
                <FontAwesome name="tablet" />
                <p className="bolder">
                  #{vehiculo.getIn(['_dispositivo', 'numero'])} - {vehiculo.getIn(['_dispositivo', 'nombre'])}{' '}
                </p>
              </Col>
            )}
          </Row>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// src/modules/vehiculos/components/itemList.js